import type { MetricSummaryProps } from './types';

export default function MetricSummary({ label, value, status, context, progress }: MetricSummaryProps) {
  const hasBoundedProgress = progress !== undefined && progress >= 0 && progress <= 100;

  return (
    <div className="min-w-0 rounded-xl bg-white p-4 ring-1 ring-gray-200 dark:bg-gray-900 dark:ring-gray-800">
      <div className="flex min-w-0 flex-wrap items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="break-words text-sm font-medium text-gray-700 dark:text-gray-200">{label}</p>
          <p className="mt-1 break-words text-2xl font-semibold tabular-nums text-club-navy-950 dark:text-white">{value}</p>
        </div>
        <p className="break-words rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-200">{status}</p>
      </div>
      {context && <p className="mt-2 break-words text-xs text-gray-500 dark:text-gray-400">{context}</p>}
      {hasBoundedProgress && (
        <div
          role="progressbar"
          aria-label={label}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={progress}
          className="mt-3 h-2 overflow-hidden rounded-full bg-gray-200 dark:bg-gray-800"
        >
          <div className="h-full rounded-full bg-club-gold-500 transition-[width] motion-reduce:transition-none" style={{ width: `${progress}%` }} />
        </div>
      )}
    </div>
  );
}
